import { CloseOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Dropdown, Input, Menu, Row, Grid } from 'antd';
import React, { useRef, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ButtonText, MenuItemText } from '../../../shared/globalStyling/styledText';

const { useBreakpoint } = Grid;

const DropDownStatusToggle = withRouter(({ location, history, orgLevel }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  let statuses = [
    { text: 'Active', key: 'ACTIVE' },
    { text: 'Paused', key: 'PAUSED' },
  ];

  // Uncomment the following line if you want to include "Demo" status
  if (orgLevel !== 'STANDARD') statuses.push({ text: 'Demo', key: 'DEMO' });
  const params = new URLSearchParams(location.search);
  const selectedStatus = params.get('status');
  return (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu selectedKeys={[selectedStatus]}>
          {statuses.map((status, i) => {
            const isSelected = selectedStatus === status.key;
            return (
              <Menu.Item
                key={`${status.text}-${i}`}
                onClick={() => {
                  if (selectedStatus) {
                    params.delete('status');
                    sessionStorage.removeItem('editorialMainStatus');
                  }
                  if (!isSelected) {
                    params.append('status', status.key);
                    sessionStorage.setItem('editorialMainStatus', status.key);
                  }
                  history.push(`/publisher/main/1?${params.toString()}`);
                }}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <Checkbox
                  checked={isSelected}
                  style={{
                    visibility: isSelected ? 'visible' : 'hidden',
                    marginRight: '8px',
                  }}
                />
                <MenuItemText text={status.text} />
              </Menu.Item>
            );
          })}
        </Menu>
      }
    >
      <Button
        style={{
          fontSize: isMobile ? '12px' : '14px',
          width: '100%',
          height: isMobile ? '32px' : '36px',
          padding: isMobile ? '4px 8px' : undefined,
        }}
        shape="round"
        type={!!selectedStatus ? 'primary' : 'default'}
        ghost={!!selectedStatus ? true : false}
      >
        <ButtonText text={'Status'} />
        <DownOutlined color="black" />
      </Button>
    </Dropdown>
  );
});

const FilterBar = ({ location, history, orgLevel }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const searchRef = useRef(null);
  const params = new URLSearchParams(location.search);
  const [searchQuery, setSearchQuery] = useState(params.get('search') || '');

  useEffect(() => {
    if (!location.search) {
      const savedSearch = sessionStorage.getItem('editorialMainSearch');
      const savedStatus = sessionStorage.getItem('editorialMainStatus');

      let hasChanges = false;
      const newParams = new URLSearchParams();

      if (savedStatus && !params.get('status')) {
        newParams.append('status', savedStatus);
        hasChanges = true;
      }

      if (savedSearch && !params.get('search')) {
        newParams.append('search', savedSearch);
        setSearchQuery(savedSearch);
        hasChanges = true;
      }

      if (hasChanges) {
        history.replace(`/publisher/main/1?${newParams.toString()}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Row className="filter-bar-container" align={'middle'} gutter={[16, 16]}>
      <Col xs={{ span: 24, order: 2 }} md={{ span: 5, order: 1 }} xl={{ span: 3 }}>
        <DropDownStatusToggle orgLevel={orgLevel} />
      </Col>
      <Col
        xs={{ span: 24, order: 1 }}
        md={{ span: 7, order: 2, offset: 7 }}
        xl={{ span: 4, offset: 15 }}
      >
        <Input.Search
          placeholder={isMobile ? 'Search...' : 'Search'}
          ref={searchRef}
          style={{
            width: '100%',
            height: isMobile ? '32px' : '36px',
            fontSize: isMobile ? '12px' : '14px'
          }}
          allowClear
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onSearch={(search) => {
            if (params.get('search')) {
              params.delete('search');
              sessionStorage.removeItem('editorialMainSearch');
            }
            if (search) {
              params.append('search', search);
              sessionStorage.setItem('editorialMainSearch', search);
              history.push(`/publisher/main/1?${params.toString()}`);
            } else {
              setSearchQuery('');
              history.push(`/publisher/main/1`);
            }
          }}
        />
      </Col>
      <Col xs={{ span: 24, order: 3 }} md={{ span: 4, order: 3 }} xl={{ span: 2 }}>
        <Button
          style={{
            width: '100%',
            height: isMobile ? '32px' : '36px',
            fontSize: isMobile ? '12px' : '14px',
            padding: isMobile ? '4px 8px' : undefined,
          }}
          shape="round"
          type={'default'}
          onClick={() => {
            setSearchQuery('');
            sessionStorage.removeItem('editorialMainSearch');
            sessionStorage.removeItem('editorialMainStatus');
            sessionStorage.removeItem('editorialMainPublisher');
            history.push(`/publisher/main/1`);
          }}
          disabled={!params.toString()}
          icon={<CloseOutlined />}
        >
          Clear
        </Button>
      </Col>
    </Row>
  );
};

export default withRouter(FilterBar);
